import { useState, useEffect } from 'react';

export default function useIsVisible(
    props: {
        threshold: number;
        initialIsVisible: boolean;
    }
) {
    const [targetRef, setTargetRef] = useState<HTMLElement | null>(null);
    const [isVisible, setIsVisible] = useState<boolean>(props.initialIsVisible);

    useEffect(() => {
        const observerOption = {
            rootMargin: '0px',
            threshold: props.threshold,
        }

        const observer = new IntersectionObserver(([entry]) => {
            setIsVisible(entry.isIntersecting);
        }, observerOption);

        if (targetRef) {
            observer.observe(targetRef);
        }

        return () => {
            if (targetRef) {
                observer.unobserve(targetRef);
            }
        }
    }, [targetRef, props.threshold]);

    return { setTargetRef, isVisible };
}